import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import TextButton from 'LuxKit/Button/TextButton'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import type { Place } from 'tripPlanner/types/common'
import { googleMapsQueryUrl } from 'tripPlanner/utils'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

const Address = styled.div`
  display: flex;
  flex-direction: column;
`

const Actions = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
  margin-top: ${rem(16)};
  width: fit-content;
`

type Props = {
  place: Place
}

function LocationWithMap({ place }: Props) {
  const intl = useIntl()

  const locationLabel = intl.formatMessage({
    id: 'skli-LW87UjWpBRXGydh',
    defaultMessage: 'Location',
    description: 'Section heading for the location section in trip item summary',
  })
  const viewOnGoogleMapsLabel = intl.formatMessage({
    id: 'dI0kfptq7yIVmCYr0Hm0',
    defaultMessage: 'View on Google Maps',
    description: 'Button text to open location in Google Maps on the map view',
  })

  return (
    <Wrapper>
      <BodyText variant="medium" weight="bold">
        {locationLabel}
      </BodyText>
      <Address>
        <BodyText variant="large">{place.name}</BodyText>
        <BodyText variant="large">{place.address}</BodyText>
      </Address>
      <Actions>
        {place.address && (
          <TextButton
            kind="secondary"
            startIcon={<LineMapIcon colour="primary" />}
            target="_blank"
            href={googleMapsQueryUrl(place.address)}
          >
            {viewOnGoogleMapsLabel}
          </TextButton>
        )}
      </Actions>
    </Wrapper>
  )
}
export default LocationWithMap
